<br /><br />
<div>
  <div>
    <div class="container">
      <div class="col-md-1" style="padding-top: 3px">
        {{ 'label.DailyDigest' | translate }}:
      </div>
      <div class="col-md-11">
        <div class="col-md-1" style="padding-left: 0px">
          <div style="width: 95px" id="switch_container">
            <div class="onoff-switch ng-scope">
              <input
                type="checkbox"
                id="daily_digest"
                checked="dailyDigestOn"
                [(ngModel)]="dailyDigestOn"
              />
              <label for="daily_digest">
                <span
                  class="inner"
                  [attr.data-on]="active"
                  [attr.data-off]="inactive"
                ></span>
                <span class="switch"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-11" style="padding-top: 3px">
          {{ dailyDigestDescription }}
        </div>
      </div>
    </div>
    <br />
    <div class="container">
      <div class="col-md-1">{{ 'label.Categories' | translate }}:</div>
      <div class="col-md-5">
        <div *ngFor="let item of leftColumnCategories">
          <input
            type="checkbox"
            name="cat_{{ item.occupationCategoryId }}"
            id="cat_{{ item.occupationCategoryId }}"
            [checked]="item.isChecked"
            (change)="item.isChecked = !item.isChecked"
          />
          <label for="cat_{{ item.occupationCategoryId }}">{{
            item.name
          }}</label
          ><br />
        </div>
      </div>
      <div class="col-md-6">
        <div *ngFor="let item of rightColumnCategories">
          <input
            type="checkbox"
            name="cat_{{ item.occupationCategoryId }}"
            id="cat_{{ item.occupationCategoryId }}"
            [checked]="item.isChecked"
            (change)="item.isChecked = !item.isChecked"
          />
          <label for="cat_{{ item.occupationCategoryId }}">{{
            item.name
          }}</label
          ><br />
        </div>
      </div>
    </div>
    <br />
    <div class="container">
      <div class="col-md-1" style="padding-top: 3px">
        {{ 'label.City' | translate }}:
      </div>
      <div class="col-md-11">
        <div class="multi-select-dropdown">
          <ul>
            <li *ngFor="let item of selectedLocalities">
              {{ item.text
              }}<button
                class="remove"
                (click)="onLocalityOptionRemoveClick(item)"
              >
                x
              </button>
            </li>
          </ul>
          <div>
            <select
              [(ngModel)]="lastSelectedLocality"
              (ngModelChange)="onLocalityChange()"
            >
              <option *ngFor="let item of localities" [ngValue]="item">
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <br />
    <p class="error" *ngIf="!isValidCombination">
      {{ invalidCombinationMessage }}
    </p>
    <br />
    <div class="container" style="padding-left: 15px">
      <div style="padding-left: 15px">
        <button (click)="onSubscriptionSaveClick()">
          {{ 'label.Save' | translate }}
        </button>
        <button (click)="onSubscriptionCancelClick()">
          {{ 'label.Cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
